/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useEffect, useState } from "react";
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import { AppContext } from "../components/AppProvider";
import { _CK, _API } from "../modules/utils";
import LoginTypeA from "./Template/Type-A/Login/Login";
import LoginTypeB from "./Template/Type-B/Login/Login";
import LoginTypeE from "./Template/Type-E/Login/Login";
import LoginDefault from "./Template/Default/Login/Login";

import TypeARoot from "./Roots/TypeARoot";
import TypeBRoot from "./Roots/TypeBRoot";
import TypeERoot from "./Roots/TypeERoot";
import Default from "./Roots/Default";

import DirectLogin from "./directLogin";
import Prereg from "./preRegister/Preregister";
// import Campaign from "./campaign/page/CampaignMain";
import Campaign from "./campaign/index";
import Preregistration from "./preRegister/Preregistration";
import useStore from "../modules/utils/store";


export default (props) => {
  const { auth, iam, saveAuth } = useContext(AppContext);
  const {siteInfo, campaignInfo} = useStore();
  const [currentHash, setCurrentHash] = useState(() => window.location.hash);

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    const hashQuery = currentHash?.indexOf("?") === -1 ? "" : currentHash.split("?")[1];
    const queryParams = new URLSearchParams(hashQuery);
    const currentAu = queryParams.get("au") || "";
    const currentDirectLoginPending = sessionStorage.getItem('__directLoginPending');
    const hasPersistedConsoleSession = _CK.hasConsoleSession();

    // 쿠키(getAuth)가 있으면 snapshot(=hasConsoleSession) 불일치만으로 로그아웃하지 않는다.
    // 실제 유효성은 App.js 의 /v1/client/iam 가 판정한다(쿠키 주석과 동일).
    // (F5 새로고침 시 snapshot 불일치로 즉시 로그아웃되던 문제 방지)
    if (auth && !_CK.getAuth() && !currentAu && !currentDirectLoginPending) {
      _CK.clearAuth();
      saveAuth("");
    }
  }, [auth, currentHash, saveAuth]);

  if (currentHash === "" || !currentHash) {
    _CK.clearAuth();
  }

  let eventIdx = "";
  let campaignIdx = "";
  let passCode = "";
  let au = "";
  let pathInfos = [];
  let pathParams = [];
  let email = '';
  let memType = '';
  let sessionIdx = '';
  let redirectHash = '';

  const pathName = currentHash;

  if (pathName) {
    pathInfos = pathName.indexOf("?") === -1 ? pathName.split("/") : pathName.split("?")[0].split("/");
    const hashQuery = pathName.indexOf("?") === -1 ? "" : pathName.split("?")[1];
    const queryParams = new URLSearchParams(hashQuery);

    passCode = queryParams.get("passCode") || "";
    au = queryParams.get("au") || "";
    email = queryParams.get("email") || "";
    memType = queryParams.get("memType") || "";
    eventIdx = pathInfos[2];
    campaignIdx = pathInfos[2];
    sessionIdx = pathInfos[4];
    if (pathName.indexOf("?") === -1) {
      redirectHash = pathName;
    } else {
      const nextHashPath = pathName.split("?")[0];
      const nextHashParams = new URLSearchParams(pathName.split("?")[1]);
      const redirectParams = new URLSearchParams();
      const domainOverride = nextHashParams.get("domain");

      if (domainOverride) {
        redirectParams.set("domain", domainOverride);
      }

      redirectHash = redirectParams.toString()
        ? `${nextHashPath}?${redirectParams.toString()}`
        : nextHashPath;
    }
  }

  if (!au && sessionStorage.getItem('__directLoginPending')) {
    sessionStorage.removeItem('__directLoginPending');
  }

  const isDirectLoginPending = sessionStorage.getItem('__directLoginPending');
  const hasPersistedConsoleSession = _CK.hasConsoleSession();

  if(pathInfos[1] == "event" && pathInfos[3] == 'regi'){
    let channel = pathName.indexOf("channel=") === -1 ? "" : pathName.split("channel=")[1].split('&')[0];
    window.location.href = `/#/event/${eventIdx}/regi`;
    return <Preregistration eventIdx={eventIdx} channel={channel}/>
    
  }

  if(pathInfos[1] == "event" && pathInfos[3] == 'preregister'){
    let channel = pathName.indexOf("channel=") === -1 ? "" : pathName.split("channel=")[1].split('&')[0];
    window.location.href = `/#/event/${eventIdx}/preregister`;
    return <Prereg eventIdx={eventIdx} channel={channel}/>
  }
  
  /* if(pathInfos[1] == "event" && pathInfos[3] == 'campaign'){
    //let channel = pathName.indexOf("channel=") === -1 ? "" : pathName.split("channel=")[1].split('&')[0];
    window.location.href = `/#/event/${eventIdx}/campaign`;
    return <Campaign eventIdx={eventIdx}/>
  } */

  if(pathInfos[1] == "campaign"){
    // window.location.href = `/#/campaign/${campaignIdx}`;
    return <Campaign campaignIdx={campaignIdx} templateIdx={campaignInfo?.templateIdx}/>
  }

  if (pathInfos[1] == "guest") {

    let eventId = pathName.split("event_id/")[1].split("/")[0];
    let sessionId = pathName.split("session_id/")[1].split("/")[0];
    let siteIdx = pathName.indexOf("siteIdx=") === -1 ? "" : pathName.split("siteIdx=")[1].split('&')[0];
    let preregIdx = pathName.indexOf("preregIdx=") === -1 ? "" : pathName.split("preregIdx=")[1].split('&')[0];

    const loginComponent = (
      <DirectLogin
        siteIdx={siteIdx}
        eventIdx={eventId}
        sessionIdx={sessionId}
        preregIdx={preregIdx}
        passCode={passCode}
        targetType={"GUEST"}
      />
    );

   
    setTimeout(() => {
      window.location.href = `/#/event/${eventId}/session/${sessionId}/default`;

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }, 500);

    return loginComponent; 
  }

  if(pathInfos[1] == "medigate"){
    eventIdx = pathName.indexOf("event_id=") === -1 ? "" : pathName.split("event_id=")[1].split('&')[0];
    sessionIdx = pathName.indexOf("session_id=") === -1 ? "" : pathName.split("session_id=")[1].split('&')[0];
    let name = pathName.indexOf("ememer_seq=") === -1 ? "" : pathName.split("ememer_seq=")[1].split('&')[0];
    let companyName = pathName.indexOf("comp_name=") === -1 ? "" : decodeURI(pathName.split("comp_name=")[1].split('&')[0]);
    if(sessionIdx){
      window.location.href = `/#/event/${eventIdx}/session/${sessionIdx}/default`;
    }else{
      window.location.href = `/#/event/${eventIdx}/register`;
    }
    return <DirectLogin eventIdx={eventIdx} sessionIdx={sessionIdx} name={name} companyName={companyName} medigate={true} au={au}/>;
  }  

  if(pathInfos[1] == "external_link"){
    eventIdx = pathName.indexOf("post_id=") === -1 ? "" : pathName.split("post_id=")[1].split('&')[0];
    sessionIdx = pathName.indexOf("session_id=") === -1 ? "" : pathName.split("session_id=")[1].split('&')[0];
    let firstName = pathName.indexOf("FirstName=") === -1 ? "" : pathName.split("FirstName=")[1].split('&')[0];
    let lastName = pathName.indexOf("LastName=") === -1 ? "" : pathName.split("LastName=")[1].split('&')[0];
    let name = decodeURI(lastName)+decodeURI(firstName);
    let email = pathName.indexOf("EmailAddress=") === -1 ? "" : decodeURI(pathName.split("EmailAddress=")[1].split('&')[0]);
    email = email?.replace('%40','@');
    let mobile = pathName.indexOf("MobileNumber=") === -1 ? "" : pathName.split("MobileNumber=")[1].split('&')[0];
    let smsAgree = pathName.indexOf("ISsubscribeforSMS=") === -1 ? "" : pathName.split("ISsubscribeforSMS=")[1].split('&')[0];
    let emailAgree = pathName.indexOf("ISsubscribeforEmail=") === -1 ? "" : pathName.split("ISsubscribeforEmail=")[1].split('&')[0];
    let companyName = pathName.indexOf("comp_name=") === -1 ? "" : decodeURI(pathName.split("comp_name=")[1].split('&')[0]);
    let remoteAddr = document.referrer;
    
    if(sessionIdx){
      window.location.href = `/#/event/${eventIdx}/session/${sessionIdx}/default`;
    }else{
      window.location.href = `/#/event/${eventIdx}/register`;
    }
    return <DirectLogin eventIdx={eventIdx} sessionIdx={sessionIdx} 
            name={name} mobile={mobile} email={email} smsAgree={smsAgree} emailAgree={emailAgree} remoteAddr={remoteAddr}
            companyName={companyName} external={true} au={au}
          />;
  }  

  if(pathInfos[1] == "event" && pathInfos[3] == 'session'){
    if(au) {
      sessionStorage.setItem('__directLoginPending', '1');
      return <DirectLogin eventIdx={eventIdx} sessionIdx={sessionIdx} passCode={passCode} au={au} email={email} memType={memType} redirectHash={redirectHash}/>;
    } /* else {
      window.location.href = `/#/event/${eventIdx}/session/${sessionIdx}/default`;
      return <DirectLogin eventIdx={eventIdx} targetType={targetType}/>;
    }  */
    
  }

  if (
    (passCode || au) &&
    pathInfos.length == 4 &&
    pathInfos[1] == "event" &&
    (pathInfos[3] == "register")
  ) {
    console.log('pathName =', pathName);
    let type = pathName.indexOf("type=") === -1 ? "" : pathName.split("type=")[1].split('&')[0];
    console.log('type3 =', type);
    window.location.href = `/#/event/${eventIdx}/${pathInfos[3]}`;
    return <DirectLogin eventIdx={eventIdx} passCode={passCode} au={au} email={email} memType={memType} type={type}/>;
  }

  // Router를 최상위로 이동 - Login도 Router 안에서 렌더링
  const getLoginComponent = () => {
    if(siteInfo?.templateIdx == 1) return LoginTypeA;
    if(siteInfo?.templateIdx == 2) return LoginTypeB;
    if(siteInfo?.templateIdx == 3) return LoginDefault;
    if(siteInfo?.templateIdx == 4) return LoginTypeE;
    return LoginTypeA;
  };
  
  const getRootComponent = () => {
    if(siteInfo?.templateIdx == 1) return TypeARoot;
    if(siteInfo?.templateIdx == 2) return TypeBRoot;
    if(siteInfo?.templateIdx == 3) return Default;
    if(siteInfo?.templateIdx == 4) return TypeERoot;
    return TypeARoot;
  };
  
  const LoginComponent = getLoginComponent();
  const RootComponent = getRootComponent();
  
  // DirectLogin 진행 중 (URL에서 au= 제거됐지만 API 응답 전) → Login 플래시 방지
  if (isDirectLoginPending && au && !_CK.isLogin() && !auth) {
    return null;
  }

  // ✅ 로그인 여부에 따라 적절한 컴포넌트 렌더링
  // 정상 브랜치(campaign_Event_sync_pannel)와 동일하게 복구: 로그인 화면 렌더 판단은
  // snapshot(hasConsoleSession) 일치가 아니라 쿠키(isLogin) 또는 auth 상태로 한다.
  // (snapshot 불일치 시 관리자 F5에서 로그인 화면이 떠버리던 문제 해결. 실제 유효성은 iam이 판정)
  const isLoggedIn = _CK.isLogin() || auth;
  
  return (
    <Router>
      {isLoggedIn ? <RootComponent /> : <LoginComponent />}
    </Router>
  );
  
};
